/**
 * cart-drawer.js — نغمة ستور
 * فتح/إغلاق درج السلة الأساسي، وعرض محتوياتها الحقيقية (بيانات Shopify).
 *
 * تصحيح جذري سابق: العمارة القديمة كانت تربط كل زر فتح/إغلاق مرة واحدة
 * فقط (dataset guard)، وتُغلق الدرج عبر متغير drawer مُغلَق (closure) على
 * العنصر وقت الربط. بما أن أزرار الفتح تعيش في قسمين منفصلين (header
 * وmobile-bottom-nav) بينما الدرج نفسه قسم ثالث منفصل تمامًا (cart-drawer)،
 * كان أي مزيج من إعادة تحميل هذه الأقسام بشكل غير متزامن من محرر الثيم
 * يُنتج إحدى مشكلتين حقيقيتين. الحل: مستمع نقر ومفتاح واحد فقط على مستوى
 * document (Delegated)، يُربط مرة واحدة فقط طوال عمر الصفحة، ويبحث عن
 * document.getElementById("CartDrawer") الحي في لحظة كل تفاعل فعلي بدل أي
 * مرجع محفوظ مسبقًا — لا مرجع قديم يُحتفَظ به أبدًا (نفس المبدأ الآن مطلوب
 * أيضًا من homepage.js بعد استبدال محتوى القسم عبر Section Rendering API).
 *
 * إضافة هذه الجولة: واجهة عامة صغيرة Naghmah.cartDrawer (open/close/getDrawer)
 * مكشوفة لملفات أخرى (تحديدًا homepage.js عند Quick Add) بدل محاكاة نقر
 * على زر آخر غير الزر الذي بدأ فعليًا التفاعل. تمرير الزر الحقيقي كـ
 * trigger إلى open() يضمن إعادة التركيز إليه هو تحديدًا بعد إغلاق الدرج
 * (عبر lastTrigger الموجود أصلاً)، لا إلى زر سلة الهيدر دائمًا.
 */
(function () {
  "use strict";

  var removeFocusTrap = null;
  var lastTrigger = null;
  var delegatedBound = false;

  function getDrawer() {
    return document.getElementById("CartDrawer");
  }

  function openDrawer(trigger) {
    var drawer = getDrawer();
    if (!drawer) return;

    // إلغاء أي مؤقت إغلاق معلَّق من فتح/إغلاق سريع سابق، حتى لا يضيف
    // hidden على الدرج بعد إعادة فتحه للتو (انظر closeDrawer أدناه).
    if (drawer.closeTimer) {
      window.clearTimeout(drawer.closeTimer);
      drawer.closeTimer = null;
    }

    drawer.removeAttribute("hidden");
    void drawer.offsetWidth;
    drawer.classList.add("is-open");
    lastTrigger = trigger || lastTrigger;
    document.querySelectorAll("[data-cart-drawer-toggle]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "true");
    });
    Naghmah.lockScroll();
    removeFocusTrap = Naghmah.trapFocus(drawer);
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer || drawer.hasAttribute("hidden")) return;
    drawer.classList.remove("is-open");
    document.querySelectorAll("[data-cart-drawer-toggle]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "false");
    });
    Naghmah.unlockScroll();
    if (removeFocusTrap) {
      removeFocusTrap();
      removeFocusTrap = null;
    }

    if (drawer.closeTimer) {
      window.clearTimeout(drawer.closeTimer);
    }
    drawer.closeTimer = window.setTimeout(function () {
      drawer.setAttribute("hidden", "");
      drawer.closeTimer = null;
    }, 220);
  }

  function closeAndRestoreFocus() {
    closeDrawer();
    var returnTo = lastTrigger || document.querySelector("[data-cart-drawer-toggle]");
    if (returnTo) returnTo.focus();
  }

  function bindDelegatedOnce() {
    if (delegatedBound) return;
    delegatedBound = true;

    document.addEventListener("click", function (evt) {
      var toggle = evt.target.closest("[data-cart-drawer-toggle]");
      if (toggle) {
        openDrawer(toggle);
        return;
      }
      var closeTrigger = evt.target.closest("[data-cart-drawer-close]");
      if (closeTrigger) {
        closeAndRestoreFocus();
      }
    });

    document.addEventListener("keydown", function (evt) {
      if (evt.key !== "Escape") return;
      var drawer = getDrawer();
      if (!drawer || drawer.hasAttribute("hidden")) return;
      closeAndRestoreFocus();
    });
  }

  function initCartDrawer() {
    // لا حاجة لأي ربط لكل عنصر بعد الآن — المستمع المفوَّض (delegated) على
    // document يتكفّل بكل الأزرار الحالية والمستقبلية تلقائيًا، بغض النظر
    // عن أي قسم أُعيد تحميله ومتى. هذه الدالة فقط تضمن ربط المستمع مرة
    // واحدة طوال عمر الصفحة.
    bindDelegatedOnce();
  }

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;

  if (Naghmah.registerSection) {
    Naghmah.registerSection("header", initCartDrawer);
    Naghmah.registerSection("mobile-bottom-nav", initCartDrawer);
    Naghmah.registerSection("cart-drawer", initCartDrawer);
  }

  // واجهة عامة صغيرة لبقية ملفات JS (مثل homepage.js عند Quick Add) —
  // getDrawer() تُعيد العنصر الحي دومًا (لا مرجع قديم مُخزَّن)، وopen()
  // تقبل عنصر الزر الذي بدأ التفاعل فعليًا لضمان إعادة التركيز الصحيح.
  Naghmah.cartDrawer = {
    open: openDrawer,
    close: closeAndRestoreFocus,
    getDrawer: getDrawer
  };

  Naghmah.onReady(initCartDrawer);
})();
